import {EDLPAnalysisBO} from "./EDLPAnalysisBO";
import {Subscription} from "rxjs/Subscription";
import {EDLPAnalysisPeroidRow, EDLPAnalysisRow} from "./EDLPAnalysisBO.Rows";
import {IHaveExecutionBounds} from "../PA.Core/PA.Core.IF.Aspects";
import {WB_CustomerRow, WB_FinishedProductRow} from "../PA.Core/PAdbSchemaRows";
import * as _ from "lodash";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {IDateRange} from "../PA.Core/PA.Core.IF.Basic";
import {MetricParameters, MetricsParameterSet} from "../PA.Metric.Services/PAMetrics";
import {PAMetricServiceClient} from "../PA.Metric.Services/PAMetricServiceClient";
import {IMetrics, IMetricsSet} from "../PA.Metric.Services/PA.Metrics.IF";
import {FinancialUtils} from "../PA.Core/Basic/FinancialUtils";

export class EDLPAnalysisCalculator {

  private EDLPAnalysisBO: EDLPAnalysisBO
  private subExecutionBounds: Subscription

  constructor(){
    this.EDLPAnalysisBO = undefined
    this.subExecutionBounds = undefined
  }

  register( aBO: EDLPAnalysisBO ): void {
    const self = this
    self.unRegister()

    self.EDLPAnalysisBO= aBO

    // Listen for Changes on 3 records, and the ExecutionBounds

    self.subExecutionBounds = aBO.ExecutionBoundsSelected.ExecutionBoundsChanged
      .subscribe(self.onExecutionBoundsChanged.bind(self))



    self.EDLPAnalysisBO.drEDLPAnalysis.setupOnChangeEvents(['Elasticity','TrueBaseCalcMethod'], self.onMainRowChange, {EDLPAnalysisCalculator: self})


    let changeFields = ['CnsStartDt','CnsEndDt','TrueBasePriceOvrd','RetailerMarginOvrd','EDLPSpendRateOvrd']

    self.EDLPAnalysisBO.drEDLPAnalysis.PriceChange.setupOnChangeEvents(changeFields, self.onPeriodRowChanged, {EDLPAnalysisCalculator: self})
    self.EDLPAnalysisBO.drEDLPAnalysis.Baseline.setupOnChangeEvents(changeFields, self.onPeriodRowChanged, {EDLPAnalysisCalculator: self})

  }

  unRegister(): void {

  }

  // Event Handlers
  onMainRowChange(record: EDLPAnalysisRow, propertyName: string, newValue: any, opts: {EDLPAnalysisCalculator: EDLPAnalysisCalculator}){
    //
    console.log("EDLP Calc: Changed field: ", propertyName, " value: ", newValue)
    opts.EDLPAnalysisCalculator.queueCalc()
  }

  onPeriodRowChanged(record: EDLPAnalysisPeroidRow, propertyName: string, newValue: any, opts: {EDLPAnalysisCalculator: EDLPAnalysisCalculator}) {
    //
    console.log("EDLP Calc: Changed field: ", propertyName, " value: ", newValue)
    switch(propertyName){
      case 'TrueBasePriceOvrd':
        if(opts.EDLPAnalysisCalculator.EDLPAnalysisBO.drEDLPAnalysis.TrueBaseCalcMethod != "Ovrd"){
          return  // don't trigger calc..
        }
        break;
      case 'RetailerMarginOvrd':
        if(opts.EDLPAnalysisCalculator.EDLPAnalysisBO.drEDLPAnalysis.TrueBaseCalcMethod != "Margin"){
          return
        }
        break;
    }
    opts.EDLPAnalysisCalculator.queueCalc()
  }

  onExecutionBoundsChanged(executionBounds: IHaveExecutionBounds){
    //
    console.log("EDLP Calc: execution bounds changed")
    this.queueCalc()
  }

  //
  queueCalc(){
    const self = this
    console.log("queueCalc")
    if(_.isEmpty(self.EDLPAnalysisBO)){ return }

    let mps = this.createPeriodMetricServiceParameterSet()
    let  aMetricServiceClient = new PAMetricServiceClient()

    aMetricServiceClient.calculateMetricSet(mps)
      .then((results: IMetricsSet) => {
        self.applyMetrics(results['Baseline'], self.EDLPAnalysisBO.drEDLPAnalysis.Baseline)
        self.applyMetrics(results['PriceChange'], self.EDLPAnalysisBO.drEDLPAnalysis.PriceChange)
      })
      .catch((err) => {
        console.log(err)
      })

  }

  private createPeriodMetricServiceParameterSet(): MetricsParameterSet {

    let eb = this.EDLPAnalysisBO.ExecutionBoundsSelected
    let mps: MetricsParameterSet = new MetricsParameterSet()

    // Generate Periods..
    // Get outside bounds of shipments and consumption

    let arrEAPeriodRows = [this.EDLPAnalysisBO.drEDLPAnalysis.Baseline, this.EDLPAnalysisBO.drEDLPAnalysis.PriceChange]
    let arrEAPeriodName = ['Baseline','PriceChange']

    for(let i = 0; i < arrEAPeriodRows.length; i++) {
      //
      let aEAP: EDLPAnalysisPeroidRow = arrEAPeriodRows[i]

      let ConsRange: IDateRange = {StartDt: aEAP.CnsStartDt, EndDt: aEAP.CnsEndDt }
      let ShipRange: IDateRange = {StartDt: undefined, EndDt: undefined }

      var mp = new MetricParameters()
      mp.MetricParameterId = arrEAPeriodName[i]
      mp.bCalculateIntersection = false
      mp.PlanningCustomers = _.map(eb.Execution_PlanningCustomers, (pcr: WB_CustomerRow) => { return pcr.cif.WB_CUST_ID })
      mp.SourceCustomers = _.map(eb.Execution_SourceCustomers, (pcr: WB_CustomerRow) => { return pcr.cif.WB_CUST_ID })
      mp.FinishedProducts = _.map(eb.Execution_FinishedProducts, (fpr: WB_FinishedProductRow) => { return fpr.cif.WB_PROD_ID })
      mp.ConsumerProductUPCs = []
      mp.Sources = []
      mp.InStoreStartDt = aEAP.CnsStartDt
      mp.InStoreEndDt = aEAP.CnsEndDt
      mp.ShipmentStartDt = undefined
      mp.ShipmentEndDt = undefined
      mp.Int_InStoreStartDt = undefined
      mp.Int_InStoreEndDt = undefined
      mp.Int_ShipmentStartDt = undefined
      mp.Int_ShipmentEndDt = undefined

      mps[mp.MetricParameterId] = mp
    }


    return mps
  }

  private applyMetrics(metrics: IMetrics, tgt: EDLPAnalysisPeroidRow){
    if(_.isEmpty(metrics) || _.isEmpty(tgt)){ return }

    //
    //   Note:  All Pcnt fields are 100 base.. not fractional.
    //
    function CvtToDisplayPcnt(aNumber: number): number {
      return Math.round(1000 * aNumber)/10
    }

    function CvtFromDisplayPcnt(aNumber: number): number {
      return  aNumber/100
    }


    try {
      //
      // Update to consider True Base Price Method..

      switch(this.EDLPAnalysisBO.drEDLPAnalysis.TrueBaseCalcMethod){
        case "Ovrd":
          tgt.RetailerMarginOvrd = CvtToDisplayPcnt(FinancialUtils.calculateMarginPcnt(tgt.TrueBasePriceOvrd, metrics.LIST_PRICE))
          break;
        case "Margin":
          tgt.TrueBasePriceOvrd = Math.round(100 * FinancialUtils.calculateSellingPrice( metrics.LIST_PRICE, tgt.RetailerMarginOvrd / 100))/100
          break;
      }


      tgt.ListPrice = metrics.LIST_PRICE
      tgt.BasePrice = metrics.RETAILER_BASE_PRICE
      tgt.NetEDLPListPrice = tgt.ListPrice - tgt.EDLPSpendRateOvrd
      tgt.ActualEveryDayMarginPcnt = CvtToDisplayPcnt(FinancialUtils.calculateMarginPcnt(tgt.BasePrice, tgt.NetEDLPListPrice))

      if((tgt.TrueBasePriceOvrd - tgt.BasePrice) > 0){
        tgt.SubsidizationPcnt = CvtToDisplayPcnt(tgt.EDLPSpendRateOvrd/(tgt.TrueBasePriceOvrd - tgt.BasePrice))
      } else {
        tgt.SubsidizationPcnt = 0
      }

      let durationInDays = DateUtils.durationInDays({StartDt: tgt.CnsStartDt, EndDt: tgt.CnsEndDt})
      let durationInWeeks = Math.ceil(durationInDays/7)
      tgt.NonPromotedPrice = metrics.RETAILER_BASE_PRICE
      tgt.WeekCount = durationInWeeks

      tgt.SyndBaseUnits = metrics.CNSMP_SYND_BASE_UNITS
      tgt.SyndBaseWt = metrics.CNSMP_SYND_BASE_WT
      tgt.SyndBaseProfit = metrics.CNSMP_SYND_BASE_PRFTCNTRB

      tgt.EDLPLiftPcnt = CvtToDisplayPcnt(FinancialUtils.calculateEDLPLift(this.EDLPAnalysisBO.drEDLPAnalysis.Elasticity, tgt.TrueBasePriceOvrd, tgt.BasePrice))
      tgt.EDLPUnits = FinancialUtils.calculateIncremental(metrics.CNSMP_SYND_BASE_UNITS, CvtFromDisplayPcnt(tgt.EDLPLiftPcnt))
      if(metrics.CNSMP_SYND_BASE_UNITS > 0){
        let pcnt = tgt.EDLPUnits / metrics.CNSMP_SYND_BASE_UNITS
        tgt.EDLPWt = pcnt * metrics.CNSMP_SYND_BASE_WT
        tgt.EDLPProfit = pcnt * metrics.CNSMP_SYND_BASE_PRFTCNTRB
      } else {
        tgt.EDLPWt = 0
        tgt.EDLPProfit = 0
      }

      tgt.TrueBaseUnits = metrics.CNSMP_SYND_BASE_UNITS - tgt.EDLPUnits
      tgt.TrueBaseWt = metrics.CNSMP_SYND_BASE_WT - tgt.EDLPWt
      tgt.TrueBaseProfit = metrics.CNSMP_SYND_BASE_PRFTCNTRB - tgt.EDLPProfit

      let edlpVarSpend = tgt.SyndBaseUnits * tgt.EDLPSpendRateOvrd
      if(edlpVarSpend > 0){
        tgt.EDLPROI = CvtToDisplayPcnt((tgt.EDLPProfit - edlpVarSpend) / (edlpVarSpend))
      } else {
        tgt.EDLPROI = 999
      }

    } catch(err) {
      console.log(err)
    }


  }

}